import {FC, useMemo} from 'react';
import clsx from 'clsx';
import {useFormatFullName} from '@/hooks/use-format-fullname';
import {DocumentContact} from '@/interfaces/document';

interface Props {
  owner: DocumentContact;
  advisorCode: string | null;
}

export const AdvisorNameCodeTile: FC<Props> = ({owner, advisorCode}) => {
  const formatFullName = useFormatFullName();

  const formattedName = useMemo(() => {
    return formatFullName(owner.firstName, owner.lastName);
  }, [owner.firstName, owner.lastName, formatFullName]);

  return (
    <div
      className={clsx(
        'w-fit rounded-md px-2 py-1 text-xs text-grey-650 transition-colors',
        'bg-greige',
        'group-hover:bg-white',
      )}
      data-testid="advisor-name-code-tile"
    >
      <span className="font-bold">{formattedName}</span>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      {advisorCode && ` - ${advisorCode}`}
    </div>
  );
};
